// extracted by mini-css-extract-plugin
export default {"InputNumber":"PropertiesAddEditScreen_InputNumber__xSS0m"};